import moment from "moment";
/**
 * Get formated date
 * @param value Ex: 2023-02-18T21:52:16.381000Z
 * @returns Ex: 04/28/2023
 */
export const getFormatedDate = (value: string) => {
    return moment(value).format('L');
}
